"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var csod = require("player-core");
var ViewSL_1 = require("./ViewSL");
var player_content_wrapper_1 = require("player-content-wrapper");
exports.ContentWrapper = player_content_wrapper_1.default;
var Panel_1 = require("player-layout-controls/controls/Panel");
exports.LayoutControlsPanel = Panel_1.Panel;
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
exports.LayoutControlsGridLayout = GridLayout_1.GridLayout;
var GridCol_1 = require("player-layout-controls/controls/GridCol");
exports.LayoutControlsGridCol = GridCol_1.GridCol;
var SectionHeader_1 = require("player-common-controls/controls/SectionHeader");
exports.CommonControlsSectionHeader = SectionHeader_1.SectionHeader;
var Text_1 = require("player-common-controls/controls/Text");
exports.CommonControlsText = Text_1.Text;
var MediaQueryContainer_1 = require("player-layout-controls/controls/MediaQueryContainer");
exports.LayoutControlsMediaQueryContainer = MediaQueryContainer_1.MediaQueryContainer;
var Button_1 = require("player-common-controls/controls/Button");
exports.CommonControlsButton = Button_1.Button;
var ButtonDropdown_1 = require("player-common-controls/controls/ButtonDropdown");
exports.CommonControlsButtonDropdown = ButtonDropdown_1.ButtonDropdown;
var JobDetailsBannerContent = (function (_super) {
    __extends(JobDetailsBannerContent, _super);
    function JobDetailsBannerContent(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-career-site';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSL = ViewSL_1.viewSL.apply(_this);
        _this.viewSL.constructor && _this.viewSL.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    JobDetailsBannerContent.prototype.componentDidMount = function () {
        this.viewSL.mounted && this.viewSL.mounted.apply(this, arguments);
    };
    JobDetailsBannerContent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSL.shouldUpdate)
            return this.viewSL.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    JobDetailsBannerContent.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSL.didUpdate && this.viewSL.didUpdate.apply(this, arguments);
    };
    JobDetailsBannerContent.prototype.componentWillUnmount = function () {
        this.viewSL.unmount && this.viewSL.unmount.apply(this, arguments);
    };
    JobDetailsBannerContent.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    JobDetailsBannerContent.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    JobDetailsBannerContent.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSL.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSL.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    JobDetailsBannerContent.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(player_content_wrapper_1.default, { key: 0, children: [
                        React.createElement(Panel_1.Panel, { key: 0, paddingTop: "Small", paddingBottom: "Medium", children: [
                                React.createElement(Panel_1.Panel, { key: 0, paddingVertical: "Xlarge", children: [
                                        React.createElement(GridLayout_1.GridLayout, { key: 0, gutterVertical: "Xsmall", colMainAxisAlignment: "Center", colMainAxisAlignmentForSm: "Start", children: [
                                                React.createElement(GridCol_1.GridCol, { key: 0, width: "12", children: [
                                                        React.createElement(SectionHeader_1.SectionHeader, { key: 0, color: "Light", size: "H1", text: _this.props.reqTitle, tag: "ReqTitle" })
                                                    ] }),
                                                React.createElement(GridCol_1.GridCol, { key: 1, width: "12", children: [
                                                        React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", colCrossAxisAlignment: "Middle", children: [
                                                                React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "Auto", children: [
                                                                        React.createElement(Text_1.Text, { key: 0, color: "Light", size: "Xlarge", text: _this.props.location, tag: "displayLocationMessage" })
                                                                    ] }),
                                                                React.createElement(GridCol_1.GridCol, { key: 1, width: "12", widthForSm: "Auto", children: [
                                                                        React.createElement(MediaQueryContainer_1.MediaQueryContainer, { key: 0, isVisible: false, isVisibleForSm: true, children: [
                                                                                React.createElement(Text_1.Text, { key: 0, color: "Light", size: "Large", text: "|" })
                                                                            ] })
                                                                    ] }),
                                                                React.createElement(GridCol_1.GridCol, { key: 2, width: "12", widthForSm: "Auto", children: [
                                                                        React.createElement(Text_1.Text, { key: 0, color: "Light", size: "Xlarge", text: _this.props.reqId, tag: "ReqId" })
                                                                    ] })
                                                            ] })
                                                    ] }),
                                                React.createElement(GridCol_1.GridCol, { key: 2, width: "12", children: [
                                                        React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Xsmall", gutterHorizontalForXs: "Small", gutterVertical: "Xsmall", gutterVerticalForSm: "Zero", colMainAxisAlignment: "Center", colMainAxisAlignmentForSm: "Start", children: [
                                                                React.createElement(GridCol_1.GridCol, { key: 0, width: "Auto", children: [
                                                                        React.createElement(Button_1.Button, { key: 0, color: "Primary", text: _this.props.applyNowButtonText, tag: "applyNowButton", isDisabled: _this.props.isApplyNowButtonDisabled, onClick: _this._proxyEvent("onApplyClick") })
                                                                    ] }),
                                                                React.createElement(GridCol_1.GridCol, { key: 1, width: "Auto", children: [
                                                                        React.createElement(ButtonDropdown_1.ButtonDropdown, { key: 0, items: _this.props.shareOptions, label: _this.props.shareBtnText, id: "shareButtonDropdownBanner", style: "bordered", tag: "shareButtonBanner", onActionClick: _this._proxyEvent("onShareClick") })
                                                                    ] }),
                                                                React.createElement(GridCol_1.GridCol, { key: 2, width: "Auto", children: [
                                                                        React.createElement(Button_1.Button, { key: 0, color: "Grey", iconName: "bookmark", text: _this.props.saveJobText, toolTip: _this.props.saveJobText, tag: "save-job-button", isDisabled: _this.props.isSaveJobDisabled, onClick: _this._proxyEvent("onSaveClick") })
                                                                    ] })
                                                            ] })
                                                    ] }),
                                                React.createElement(GridCol_1.GridCol, { key: 3, width: "12", children: [
                                                        React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Small", colCrossAxisAlignment: "Middle", children: [
                                                                React.createElement(GridCol_1.GridCol, { key: 0, width: "12", widthForSm: "Auto", children: [
                                                                        React.createElement(Text_1.Text, { key: 0, color: "Light", size: "Xlarge", text: _this.props.postedDateLabel, tag: "postingDates" })
                                                                    ] })
                                                            ] })
                                                    ] })
                                            ] })
                                    ] })
                            ] })
                    ] })
            ];
        };
        return root_handler();
    };
    JobDetailsBannerContent.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSL-jobdetailsbannercontent" }, this._renderView()));
    };
    return JobDetailsBannerContent;
}(React.Component));
JobDetailsBannerContent.defaultProps = {
    backgroundImage: '', reqId: '', reqTitle: '', location: '', applyNowButtonText: '', shareBtnText: '', shareOptions: [], isApplyNowButtonDisabled: true, saveJobText: '', isSaveJobDisabled: true, bannerContentHeight: undefined, postedDateLabel: undefined, onApplyClick: function () { }, onSaveClick: function () { }, onShareClick: function () { }, setContentHeight: function () { }
};
exports.JobDetailsBannerContent = JobDetailsBannerContent;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["JobDetailsBannerContent"] = [];



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsBannerContent/JobDetailsBannerContent.js
// module id = 968
// module chunks = 0